
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.997 6.667H20v-2a2 2 0 00-2-2h-6.667L8.667 0H2a2 2 0 00-2 2v12a2 2 0 002 2h16.667a2 2 0 001.696-.941l3.33-5.334c.833-1.329-.126-3.058-1.696-3.058zM2 2.25A.25.25 0 012.25 2h5.588l2.667 2.667h7.246a.25.25 0 01.25.25v1.75H6.334c-.7 0-1.35.367-1.713.967l-2.62 4.341V2.25zM18.667 14H3l3.217-5.333H22L18.667 14z","fill":"#000"}})])
          )
        }
      }
    